export const regionData = [
  {
    "regionCode": "1",
    "regionName": "강원도 강릉시",
    "obesityRate": 34.0,
    "depressionRate": 6.8,
    "population": 209439,
    "coordinates": [
        37.886672999999995,
        128.762214
    ]
},
  {
    "regionCode": "3",
    "regionName": "강원도 고성군",
    "obesityRate": 35.6,
    "depressionRate": 4.6,
    "population": 27305,
    "coordinates": [
        38.332836,
        128.391823
    ]
},
  {
    "regionCode": "4",
    "regionName": "강원도 동해시",
    "obesityRate": 36.8,
    "depressionRate": 5.5,
    "population": 88625,
    "coordinates": [
        37.520573000000006,
        129.098713
    ]
},
  {
    "regionCode": "5",
    "regionName": "강원도 삼척시",
    "obesityRate": 38.5,
    "depressionRate": 8.7,
    "population": 62651,
    "coordinates": [
        37.230650000000004,
        129.072011
    ]
},
  {
    "regionCode": "6",
    "regionName": "강원도 속초시",
    "obesityRate": 35.2,
    "depressionRate": 5.8,
    "population": 82054,
    "coordinates": [
        38.215770000000006,
        128.592809
    ]
},
  {
    "regionCode": "7",
    "regionName": "강원도 양구군",
    "obesityRate": 40.8,
    "depressionRate": 4.4,
    "population": 21056,
    "coordinates": [
        38.11421199999999,
        127.95285300000002
    ]
},
  {
    "regionCode": "8",
    "regionName": "강원도 양양군",
    "obesityRate": 35.9,
    "depressionRate": 7.2,
    "population": 27710,
    "coordinates": [
        38.09160299999999,
        128.600663
    ]
},
  {
    "regionCode": "9",
    "regionName": "강원도 영월군",
    "obesityRate": 34.3,
    "depressionRate": 8.5,
    "population": 37332,
    "coordinates": [
        37.201995999999994,
        128.510833
    ]
},
  {
    "regionCode": "10",
    "regionName": "강원도 원주시",
    "obesityRate": 31.6,
    "depressionRate": 7.2,
    "population": 361503,
    "coordinates": [
        37.29141800000001,
        127.81640400000002
    ]
},
  {
    "regionCode": "11",
    "regionName": "강원도 인제군",
    "obesityRate": 38.4,
    "depressionRate": 2.7,
    "population": 32020,
    "coordinates": [
        38.065981,
        128.24819
    ]
},
  {
    "regionCode": "12",
    "regionName": "강원도 정선군",
    "obesityRate": 35.7,
    "depressionRate": 3.6,
    "population": 34202,
    "coordinates": [
        37.38041,
        128.622824
    ]
},
  {
    "regionCode": "13",
    "regionName": "강원도 철원군",
    "obesityRate": 41.3,
    "depressionRate": 5.9,
    "population": 41448,
    "coordinates": [
        38.263118000000006,
        127.173815
    ]
},
  {
    "regionCode": "14",
    "regionName": "강원도 춘천시",
    "obesityRate": 33.3,
    "depressionRate": 6.8,
    "population": 286426,
    "coordinates": [
        37.96009000000001,
        127.753618
    ]
},
  {
    "regionCode": "15",
    "regionName": "강원도 태백시",
    "obesityRate": 39.4,
    "depressionRate": 6.1,
    "population": 38702,
    "coordinates": [
        37.171271000000004,
        128.966912
    ]
},
  {
    "regionCode": "16",
    "regionName": "강원도 평창군",
    "obesityRate": 33.1,
    "depressionRate": 6.2,
    "population": 40659,
    "coordinates": [
        37.37167000000001,
        128.391387
    ]
},
  {
    "regionCode": "17",
    "regionName": "강원도 홍천군",
    "obesityRate": 38.0,
    "depressionRate": 9.4,
    "population": 67309,
    "coordinates": [
        37.66427300000001,
        127.874011
    ]
},
  {
    "regionCode": "18",
    "regionName": "강원도 화천군",
    "obesityRate": 41.3,
    "depressionRate": 6.1,
    "population": 23007,
    "coordinates": [
        38.185486,
        127.78252800000001
    ]
},
  {
    "regionCode": "19",
    "regionName": "강원도 횡성군",
    "obesityRate": 35.4,
    "depressionRate": 4.9,
    "population": 46359,
    "coordinates": [
        37.490640000000006,
        127.99585800000001
    ]
},
  {
    "regionCode": "20",
    "regionName": "경기도 가평군",
    "obesityRate": 34.8,
    "depressionRate": 5.9,
    "population": 62302,
    "coordinates": [
        37.82881900000001,
        127.487518
    ]
},
  {
    "regionCode": "26",
    "regionName": "경기도 과천시",
    "obesityRate": 22.7,
    "depressionRate": 7.8,
    "population": 81000,
    "coordinates": [
        37.433968,
        126.976933
    ]
},
  {
    "regionCode": "27",
    "regionName": "경기도 광명시",
    "obesityRate": 29.2,
    "depressionRate": 4.0,
    "population": 280197,
    "coordinates": [
        37.488626000000004,
        126.86268099999998
    ]
},
  {
    "regionCode": "28",
    "regionName": "경기도 광주시",
    "obesityRate": 35.8,
    "depressionRate": 5.5,
    "population": 391377,
    "coordinates": [
        37.361719,
        127.21211100000001
    ]
},
  {
    "regionCode": "29",
    "regionName": "경기도 구리시",
    "obesityRate": 32.4,
    "depressionRate": 5.2,
    "population": 187093,
    "coordinates": [
        37.631643,
        127.118113
    ]
},
  {
    "regionCode": "30",
    "regionName": "경기도 군포시",
    "obesityRate": 32.8,
    "depressionRate": 7.8,
    "population": 261229,
    "coordinates": [
        37.353633,
        126.94558400000001
    ]
},
  {
    "regionCode": "31",
    "regionName": "경기도 김포시",
    "obesityRate": 34.8,
    "depressionRate": 9.2,
    "population": 486172,
    "coordinates": [
        37.695994999999996,
        126.59959900000001
    ]
},
  {
    "regionCode": "32",
    "regionName": "경기도 남양주시",
    "obesityRate": 33.4,
    "depressionRate": 8.8,
    "population": 732265,
    "coordinates": [
        37.594026,
        127.247094
    ]
},
  {
    "regionCode": "35",
    "regionName": "경기도 동두천시",
    "obesityRate": 38.3,
    "depressionRate": 11.3,
    "population": 88626,
    "coordinates": [
        37.907354,
        127.06558200000002
    ]
},
  {
    "regionCode": "36",
    "regionName": "경기도 부천시",
    "obesityRate": 33.7,
    "depressionRate": 6.8,
    "population": 779968,
    "coordinates": [
        37.489198,
        126.780918
    ]
},
  {
    "regionCode": "49",
    "regionName": "경기도 시흥시",
    "obesityRate": 31.0,
    "depressionRate": 8.3,
    "population": 519715,
    "coordinates": [
        37.455404,
        126.78822600000001
    ]
},
  {
    "regionCode": "53",
    "regionName": "경기도 안성시",
    "obesityRate": 34.4,
    "depressionRate": 8.8,
    "population": 189034,
    "coordinates": [
        36.994714,
        127.173594
    ]
},
  {
    "regionCode": "57",
    "regionName": "경기도 양주시",
    "obesityRate": 37.8,
    "depressionRate": 6.7,
    "population": 268026,
    "coordinates": [
        37.788907,
        126.977622
    ]
},
  {
    "regionCode": "58",
    "regionName": "경기도 양평군",
    "obesityRate": 35.9,
    "depressionRate": 6.9,
    "population": 125238,
    "coordinates": [
        37.493552000000015,
        127.514053
    ]
},
  {
    "regionCode": "59",
    "regionName": "경기도 여주시",
    "obesityRate": 34.6,
    "depressionRate": 8.5,
    "population": 114412,
    "coordinates": [
        37.20918399999999,
        127.580168
    ]
},
  {
    "regionCode": "60",
    "regionName": "경기도 연천군",
    "obesityRate": 38.8,
    "depressionRate": 8.7,
    "population": 41584,
    "coordinates": [
        38.10027200000001,
        127.114677
    ]
},
  {
    "regionCode": "61",
    "regionName": "경기도 오산시",
    "obesityRate": 38.0,
    "depressionRate": 9.2,
    "population": 229656,
    "coordinates": [
        37.14923300000001,
        127.07056699999998
    ]
},
  {
    "regionCode": "66",
    "regionName": "경기도 의왕시",
    "obesityRate": 29.5,
    "depressionRate": 7.2,
    "population": 158870,
    "coordinates": [
        37.345427000000015,
        126.969422
    ]
},
  {
    "regionCode": "67",
    "regionName": "경기도 의정부시",
    "obesityRate": 31.7,
    "depressionRate": 5.2,
    "population": 464213,
    "coordinates": [
        37.746353,
        127.047571
    ]
},
  {
    "regionCode": "68",
    "regionName": "경기도 이천시",
    "obesityRate": 34.9,
    "depressionRate": 7.0,
    "population": 222098,
    "coordinates": [
        37.134708,
        127.596404
    ]
},
  {
    "regionCode": "69",
    "regionName": "경기도 파주시",
    "obesityRate": 34.9,
    "depressionRate": 6.3,
    "population": 497753,
    "coordinates": [
        37.874165,
        126.780387
    ]
},
  {
    "regionCode": "70",
    "regionName": "경기도 평택시",
    "obesityRate": 38.3,
    "depressionRate": 5.8,
    "population": 591022,
    "coordinates": [
        36.96135100000001,
        127.036877
    ]
},
  {
    "regionCode": "73",
    "regionName": "경기도 포천시",
    "obesityRate": 39.1,
    "depressionRate": 9.6,
    "population": 143323,
    "coordinates": [
        37.794298,
        127.149043
    ]
},
  {
    "regionCode": "74",
    "regionName": "경기도 하남시",
    "obesityRate": 31.5,
    "depressionRate": 8.2,
    "population": 329861,
    "coordinates": [
        37.52813499999999,
        127.21439200000002
    ]
},
  {
    "regionCode": "75",
    "regionName": "경기도 화성시",
    "obesityRate": 34.7,
    "depressionRate": 7.9,
    "population": 944342,
    "coordinates": [
        37.20391700000001,
        126.939222
    ]
},
  {
    "regionCode": "79",
    "regionName": "경상남도 거제시",
    "obesityRate": 33.3,
    "depressionRate": 8.2,
    "population": 234038,
    "coordinates": [
        34.82093499999999,
        128.694657
    ]
},
  {
    "regionCode": "80",
    "regionName": "경상남도 거창군",
    "obesityRate": 31.7,
    "depressionRate": 5.4,
    "population": 60047,
    "coordinates": [
        35.697624999999995,
        127.9092
    ]
},
  {
    "regionCode": "82",
    "regionName": "경상남도 고성군",
    "obesityRate": 31.4,
    "depressionRate": 8.6,
    "population": 49468,
    "coordinates": [
        34.977336,
        128.315542
    ]
},
  {
    "regionCode": "83",
    "regionName": "경상남도 김해시",
    "obesityRate": 34.1,
    "depressionRate": 4.8,
    "population": 533659,
    "coordinates": [
        35.29457,
        128.739404
    ]
},
  {
    "regionCode": "84",
    "regionName": "경상남도 남해군",
    "obesityRate": 27.2,
    "depressionRate": 7.4,
    "population": 40780,
    "coordinates": [
        34.831621999999996,
        127.890755
    ]
},
  {
    "regionCode": "86",
    "regionName": "경상남도 밀양시",
    "obesityRate": 30.3,
    "depressionRate": 6.7,
    "population": 102084,
    "coordinates": [
        35.426127,
        128.841246
    ]
},
  {
    "regionCode": "87",
    "regionName": "경상남도 사천시",
    "obesityRate": 33.9,
    "depressionRate": 7.1,
    "population": 234038,
    "coordinates": [
        35.092146,
        128.118677
    ]
},
  {
    "regionCode": "88",
    "regionName": "경상남도 산청군",
    "obesityRate": 27.0,
    "depressionRate": 3.6,
    "population": 33752,
    "coordinates": [
        35.407446,
        127.900454
    ]
},
  {
    "regionCode": "89",
    "regionName": "경상남도 양산시",
    "obesityRate": 31.5,
    "depressionRate": 3.3,
    "population": 355122,
    "coordinates": [
        35.315318000000005,
        129.000303
    ]
},
  {
    "regionCode": "90",
    "regionName": "경상남도 의령군",
    "obesityRate": 34.0,
    "depressionRate": 5.4,
    "population": 25475,
    "coordinates": [
        35.30349400000001,
        128.263066
    ]
},
  {
    "regionCode": "91",
    "regionName": "경상남도 진주시",
    "obesityRate": 30.3,
    "depressionRate": 6.0,
    "population": 341074,
    "coordinates": [
        35.157306,
        128.181128
    ]
},
  {
    "regionCode": "93",
    "regionName": "경상남도 창녕군",
    "obesityRate": 27.7,
    "depressionRate": 2.4,
    "population": 57083,
    "coordinates": [
        35.52417899999999,
        128.519708
    ]
},
  {
    "regionCode": "101",
    "regionName": "경상남도 통영시",
    "obesityRate": 33.9,
    "depressionRate": 10.8,
    "population": 120551,
    "coordinates": [
        34.79481500000001,
        128.392893
    ]
},
  {
    "regionCode": "104",
    "regionName": "경상남도 하동군",
    "obesityRate": 29.2,
    "depressionRate": 3.5,
    "population": 41606,
    "coordinates": [
        35.08589899999999,
        127.73755200000001
    ]
},
  {
    "regionCode": "105",
    "regionName": "경상남도 함안군",
    "obesityRate": 28.6,
    "depressionRate": 5.6,
    "population": 60203,
    "coordinates": [
        35.27347799999999,
        128.395224
    ]
},
  {
    "regionCode": "106",
    "regionName": "경상남도 함양군",
    "obesityRate": 30.8,
    "depressionRate": 8.7,
    "population": 36945,
    "coordinates": [
        35.499966,
        127.70355199999999
    ]
},
  {
    "regionCode": "107",
    "regionName": "경상남도 합천군",
    "obesityRate": 32.6,
    "depressionRate": 2.5,
    "population": 41203,
    "coordinates": [
        35.60775700000001,
        128.139478
    ]
},
  {
    "regionCode": "108",
    "regionName": "경상북도 경산시",
    "obesityRate": 31.2,
    "depressionRate": 9.3,
    "population": 266205,
    "coordinates": [
        35.91377099999999,
        128.787191
    ]
},
  {
    "regionCode": "110",
    "regionName": "경상북도 경주시",
    "obesityRate": 28.7,
    "depressionRate": 11.0,
    "population": 247489,
    "coordinates": [
        35.806238,
        129.478526
    ]
},
  {
    "regionCode": "111",
    "regionName": "경상북도 고령군",
    "obesityRate": 30.4,
    "depressionRate": 5.9,
    "population": 30139,
    "coordinates": [
        35.729298,
        128.19705000000002
    ]
},
  {
    "regionCode": "112",
    "regionName": "경상북도 구미시",
    "obesityRate": 33.2,
    "depressionRate": 7.2,
    "population": 405506,
    "coordinates": [
        36.24250700000001,
        128.292813
    ]
},
  {
    "regionCode": "116",
    "regionName": "경상북도 김천시",
    "obesityRate": 27.9,
    "depressionRate": 8.6,
    "population": 137515,
    "coordinates": [
        36.15546,
        128.249745
    ]
},
  {
    "regionCode": "117",
    "regionName": "경상북도 문경시",
    "obesityRate": 28.8,
    "depressionRate": 6.9,
    "population": 68755,
    "coordinates": [
        36.76968699999999,
        128.127574
    ]
},
  {
    "regionCode": "118",
    "regionName": "경상북도 봉화군",
    "obesityRate": 26.2,
    "depressionRate": 7.2,
    "population": 29603,
    "coordinates": [
        36.889986,
        128.707302
    ]
},
  {
    "regionCode": "119",
    "regionName": "경상북도 상주시",
    "obesityRate": 31.3,
    "depressionRate": 2.2,
    "population": 93858,
    "coordinates": [
        36.549604999999985,
        128.197772
    ]
},
  {
    "regionCode": "120",
    "regionName": "경상북도 성주군",
    "obesityRate": 28.2,
    "depressionRate": 6.1,
    "population": 42086,
    "coordinates": [
        35.91798,
        128.280543
    ]
},
  {
    "regionCode": "121",
    "regionName": "경상북도 안동시",
    "obesityRate": 30.3,
    "depressionRate": 6.9,
    "population": 152935,
    "coordinates": [
        36.593971,
        128.585186
    ]
},
  {
    "regionCode": "122",
    "regionName": "경상북도 영덕군",
    "obesityRate": 29.1,
    "depressionRate": 3.5,
    "population": 34055,
    "coordinates": [
        36.437062,
        129.381419
    ]
},
  {
    "regionCode": "124",
    "regionName": "경상북도 영주시",
    "obesityRate": 32.0,
    "depressionRate": 7.8,
    "population": 100199,
    "coordinates": [
        36.901989,
        128.488954
    ]
},
  {
    "regionCode": "125",
    "regionName": "경상북도 영천시",
    "obesityRate": 36.9,
    "depressionRate": 9.2,
    "population": 100212,
    "coordinates": [
        35.921699,
        128.899361
    ]
},
  {
    "regionCode": "126",
    "regionName": "경상북도 예천군",
    "obesityRate": 27.7,
    "depressionRate": 1.0,
    "population": 55325,
    "coordinates": [
        36.65666500000001,
        128.453439
    ]
},
  {
    "regionCode": "127",
    "regionName": "경상북도 울릉군",
    "obesityRate": 34.2,
    "depressionRate": 7.0,
    "population": 9077,
    "coordinates": [
        37.495375,
        130.898288
    ]
},
  {
    "regionCode": "128",
    "regionName": "경상북도 울진군",
    "obesityRate": 31.6,
    "depressionRate": 8.2,
    "population": 46669,
    "coordinates": [
        37.001052,
        129.346034
    ]
},
  {
    "regionCode": "129",
    "regionName": "경상북도 의성군",
    "obesityRate": 29.1,
    "depressionRate": 7.9,
    "population": 50086,
    "coordinates": [
        36.348986,
        128.699871
    ]
},
  {
    "regionCode": "130",
    "regionName": "경상북도 청도군",
    "obesityRate": 33.6,
    "depressionRate": 8.9,
    "population": 41316,
    "coordinates": [
        35.666045000000004,
        128.716272
    ]
},
  {
    "regionCode": "131",
    "regionName": "경상북도 청송군",
    "obesityRate": 31.5,
    "depressionRate": 3.5,
    "population": 24019,
    "coordinates": [
        36.423023,
        129.09837
    ]
},
  {
    "regionCode": "132",
    "regionName": "경상북도 칠곡군",
    "obesityRate": 31.7,
    "depressionRate": 6.1,
    "population": 110581,
    "coordinates": [
        35.977306999999996,
        128.424051
    ]
},
  {
    "regionCode": "136",
    "regionName": "광주광역시 광산구",
    "obesityRate": 33.1,
    "depressionRate": 5.5,
    "population": 396741,
    "coordinates": [
        35.140717,
        126.798867
    ]
},
  {
    "regionCode": "138",
    "regionName": "광주광역시 남구",
    "obesityRate": 32.8,
    "depressionRate": 2.4,
    "population": 209646,
    "coordinates": [
        35.138427,
        126.914392
    ]
},
  {
    "regionCode": "139",
    "regionName": "광주광역시 동구",
    "obesityRate": 28.2,
    "depressionRate": 6.7,
    "population": 107176,
    "coordinates": [
        35.149211,
        126.917783
    ]
},
  {
    "regionCode": "140",
    "regionName": "광주광역시 북구",
    "obesityRate": 29.0,
    "depressionRate": 7.8,
    "population": 421683,
    "coordinates": [
        35.161642,
        126.91394100000001
    ]
},
  {
    "regionCode": "141",
    "regionName": "광주광역시 서구",
    "obesityRate": 31.9,
    "depressionRate": 4.5,
    "population": 283991,
    "coordinates": [
        35.15451799999999,
        126.899581
    ]
},
  {
    "regionCode": "142",
    "regionName": "대구광역시 남구",
    "obesityRate": 30.5,
    "depressionRate": 4.7,
    "population": 139187,
    "coordinates": [
        35.851507,
        128.602134
    ]
},
  {
    "regionCode": "143",
    "regionName": "대구광역시 달서구",
    "obesityRate": 34.9,
    "depressionRate": 5.5,
    "population": 527781,
    "coordinates": [
        35.844571,
        128.556307
    ]
},
  {
    "regionCode": "144",
    "regionName": "대구광역시 달성군",
    "obesityRate": 33.5,
    "depressionRate": 5.7,
    "population": 262084,
    "coordinates": [
        35.78648799999999,
        128.512007
    ]
},
  {
    "regionCode": "146",
    "regionName": "대구광역시 동구",
    "obesityRate": 33.2,
    "depressionRate": 7.5,
    "population": 342813,
    "coordinates": [
        35.884269999999994,
        128.616326
    ]
},
  {
    "regionCode": "147",
    "regionName": "대구광역시 북구",
    "obesityRate": 33.2,
    "depressionRate": 5.9,
    "population": 419624,
    "coordinates": [
        35.881908,
        128.583857
    ]
},
  {
    "regionCode": "148",
    "regionName": "대구광역시 서구",
    "obesityRate": 32.1,
    "depressionRate": 3.2,
    "population": 164088,
    "coordinates": [
        35.860684000000006,
        128.560726
    ]
},
  {
    "regionCode": "149",
    "regionName": "대구광역시 수성구",
    "obesityRate": 22.0,
    "depressionRate": 4.8,
    "population": 407331,
    "coordinates": [
        35.855533,
        128.622115
    ]
},
  {
    "regionCode": "150",
    "regionName": "대구광역시 중구",
    "obesityRate": 28.4,
    "depressionRate": 7.8,
    "population": 89064,
    "coordinates": [
        35.867884000000004,
        128.609112
    ]
},
  {
    "regionCode": "151",
    "regionName": "대전광역시 대덕구",
    "obesityRate": 33.0,
    "depressionRate": 5.7,
    "population": 169853,
    "coordinates": [
        36.353852999999994,
        127.41400400000002
    ]
},
  {
    "regionCode": "153",
    "regionName": "대전광역시 동구",
    "obesityRate": 32.4,
    "depressionRate": 3.2,
    "population": 217628,
    "coordinates": [
        36.334595,
        127.438787
    ]
},
  {
    "regionCode": "154",
    "regionName": "대전광역시 서구",
    "obesityRate": 21.7,
    "depressionRate": 4.1,
    "population": 464634,
    "coordinates": [
        36.302356,
        127.376643
    ]
},
  {
    "regionCode": "155",
    "regionName": "대전광역시 유성구",
    "obesityRate": 32.4,
    "depressionRate": 9.6,
    "population": 366845,
    "coordinates": [
        36.299828000000005,
        127.316406
    ]
},
  {
    "regionCode": "156",
    "regionName": "대전광역시 중구",
    "obesityRate": 31.8,
    "depressionRate": 7.6,
    "population": 223256,
    "coordinates": [
        36.332381,
        127.41678200000001
    ]
},
  {
    "regionCode": "157",
    "regionName": "부산광역시 강서구",
    "obesityRate": 31.1,
    "depressionRate": 3.8,
    "population": 142396,
    "coordinates": [
        35.21108100000001,
        128.966063
    ]
},
  {
    "regionCode": "158",
    "regionName": "부산광역시 금정구",
    "obesityRate": 28.9,
    "depressionRate": 7.6,
    "population": 215590,
    "coordinates": [
        35.243036,
        129.092125
    ]
},
  {
    "regionCode": "159",
    "regionName": "부산광역시 기장군",
    "obesityRate": 35.3,
    "depressionRate": 8.9,
    "population": 178729,
    "coordinates": [
        35.225964999999995,
        129.20693
    ]
},
  {
    "regionCode": "160",
    "regionName": "부산광역시 남구",
    "obesityRate": 31.8,
    "depressionRate": 3.6,
    "population": 254185,
    "coordinates": [
        35.136317999999996,
        129.084477
    ]
},
  {
    "regionCode": "161",
    "regionName": "부산광역시 동구",
    "obesityRate": 31.4,
    "depressionRate": 8.2,
    "population": 87792,
    "coordinates": [
        35.129298000000006,
        129.045302
    ]
},
  {
    "regionCode": "162",
    "regionName": "부산광역시 동래구",
    "obesityRate": 29.5,
    "depressionRate": 3.7,
    "population": 270815,
    "coordinates": [
        35.196021,
        129.091035
    ]
},
  {
    "regionCode": "164",
    "regionName": "부산광역시 부산진구",
    "obesityRate": 30.4,
    "depressionRate": 7.3,
    "population": 359508,
    "coordinates": [
        35.162943000000006,
        129.053097
    ]
},
  {
    "regionCode": "165",
    "regionName": "부산광역시 북구",
    "obesityRate": 30.2,
    "depressionRate": 6.2,
    "population": 273596,
    "coordinates": [
        35.197266000000006,
        128.990201
    ]
},
  {
    "regionCode": "166",
    "regionName": "부산광역시 사상구",
    "obesityRate": 31.0,
    "depressionRate": 7.2,
    "population": 202932,
    "coordinates": [
        35.175084,
        128.972268
    ]
},
  {
    "regionCode": "167",
    "regionName": "부산광역시 사하구",
    "obesityRate": 33.9,
    "depressionRate": 6.2,
    "population": 297831,
    "coordinates": [
        35.10450300000001,
        128.974786
    ]
},
  {
    "regionCode": "168",
    "regionName": "부산광역시 서구",
    "obesityRate": 28.5,
    "depressionRate": 5.9,
    "population": 104089,
    "coordinates": [
        35.097688999999995,
        129.023906
    ]
},
  {
    "regionCode": "169",
    "regionName": "부산광역시 수영구",
    "obesityRate": 28.8,
    "depressionRate": 7.1,
    "population": 174518,
    "coordinates": [
        35.14556799999999,
        129.113132
    ]
},
  {
    "regionCode": "170",
    "regionName": "부산광역시 연제구",
    "obesityRate": 31.5,
    "depressionRate": 7.5,
    "population": 205766,
    "coordinates": [
        35.176272999999995,
        129.07981400000003
    ]
},
  {
    "regionCode": "171",
    "regionName": "부산광역시 영도구",
    "obesityRate": 35.7,
    "depressionRate": 8.3,
    "population": 106548,
    "coordinates": [
        35.089974,
        129.037595
    ]
},
  {
    "regionCode": "172",
    "regionName": "부산광역시 중구",
    "obesityRate": 30.4,
    "depressionRate": 7.0,
    "population": 38619,
    "coordinates": [
        35.101324,
        129.035325
    ]
},
  {
    "regionCode": "173",
    "regionName": "부산광역시 해운대구",
    "obesityRate": 32.3,
    "depressionRate": 9.6,
    "population": 380448,
    "coordinates": [
        35.163096,
        129.1635
    ]
},
  {
    "regionCode": "174",
    "regionName": "서울특별시 강남구",
    "obesityRate": 24.1,
    "depressionRate": 8.4,
    "population": 544873,
    "coordinates": [
        37.523807,
        127.026492
    ]
},
  {
    "regionCode": "175",
    "regionName": "서울특별시 강동구",
    "obesityRate": 29.2,
    "depressionRate": 8.5,
    "population": 459167,
    "coordinates": [
        37.567438,
        127.17336399999999
    ]
},
  {
    "regionCode": "176",
    "regionName": "서울특별시 강북구",
    "obesityRate": 35.2,
    "depressionRate": 6.3,
    "population": 288113,
    "coordinates": [
        37.627368,
        127.01830000000001
    ]
},
  {
    "regionCode": "177",
    "regionName": "서울특별시 강서구",
    "obesityRate": 30.3,
    "depressionRate": 9.2,
    "population": 563058,
    "coordinates": [
        37.554551999999994,
        126.871764
    ]
},
  {
    "regionCode": "178",
    "regionName": "서울특별시 관악구",
    "obesityRate": 32.6,
    "depressionRate": 10.2,
    "population": 481956,
    "coordinates": [
        37.488208,
        126.932761
    ]
},
  {
    "regionCode": "179",
    "regionName": "서울특별시 광진구",
    "obesityRate": 30.5,
    "depressionRate": 6.8,
    "population": 335554,
    "coordinates": [
        37.54325000000001,
        127.073393
    ]
},
  {
    "regionCode": "180",
    "regionName": "서울특별시 구로구",
    "obesityRate": 35.9,
    "depressionRate": 5.9,
    "population": 392405,
    "coordinates": [
        37.50995100000001,
        126.88217400000002
    ]
},
  {
    "regionCode": "181",
    "regionName": "서울특별시 금천구",
    "obesityRate": 34.1,
    "depressionRate": 11.9,
    "population": 227481,
    "coordinates": [
        37.476681000000006,
        126.883767
    ]
},
  {
    "regionCode": "182",
    "regionName": "서울특별시 노원구",
    "obesityRate": 29.6,
    "depressionRate": 6.0,
    "population": 498213,
    "coordinates": [
        37.619918999999996,
        127.062984
    ]
},
  {
    "regionCode": "183",
    "regionName": "서울특별시 도봉구",
    "obesityRate": 30.7,
    "depressionRate": 9.3,
    "population": 306948,
    "coordinates": [
        37.668639,
        127.04736399999999
    ]
},
  {
    "regionCode": "184",
    "regionName": "서울특별시 동대문구",
    "obesityRate": 32.6,
    "depressionRate": 3.0,
    "population": 341149,
    "coordinates": [
        37.575868,
        127.03730500000002
    ]
},
  {
    "regionCode": "185",
    "regionName": "서울특별시 동작구",
    "obesityRate": 32.9,
    "depressionRate": 9.6,
    "population": 378769,
    "coordinates": [
        37.512462,
        126.93948500000002
    ]
},
  {
    "regionCode": "186",
    "regionName": "서울특별시 마포구",
    "obesityRate": 32.2,
    "depressionRate": 8.8,
    "population": 363697,
    "coordinates": [
        37.554474,
        126.95630799999999
    ]
},
  {
    "regionCode": "187",
    "regionName": "서울특별시 서대문구",
    "obesityRate": 31.0,
    "depressionRate": 8.5,
    "population": 306231,
    "coordinates": [
        37.567945,
        126.95943700000001
    ]
},
  {
    "regionCode": "189",
    "regionName": "서울특별시 서초구",
    "obesityRate": 25.4,
    "depressionRate": 7.9,
    "population": 407664,
    "coordinates": [
        37.490077,
        127.01953400000001
    ]
},
  {
    "regionCode": "190",
    "regionName": "서울특별시 성동구",
    "obesityRate": 27.8,
    "depressionRate": 6.0,
    "population": 277361,
    "coordinates": [
        37.563386,
        127.03704700000002
    ]
},
  {
    "regionCode": "191",
    "regionName": "서울특별시 성북구",
    "obesityRate": 31.9,
    "depressionRate": 7.9,
    "population": 425602,
    "coordinates": [
        37.597248,
        126.99289900000001
    ]
},
  {
    "regionCode": "192",
    "regionName": "서울특별시 송파구",
    "obesityRate": 27.4,
    "depressionRate": 7.8,
    "population": 654166,
    "coordinates": [
        37.538055,
        127.12221500000001
    ]
},
  {
    "regionCode": "193",
    "regionName": "서울특별시 양천구",
    "obesityRate": 29.5,
    "depressionRate": 5.2,
    "population": 436028,
    "coordinates": [
        37.53043300000001,
        126.870985
    ]
},
  {
    "regionCode": "194",
    "regionName": "서울특별시 영등포구",
    "obesityRate": 28.6,
    "depressionRate": 6.5,
    "population": 374794,
    "coordinates": [
        37.514692,
        126.90938699999998
    ]
},
  {
    "regionCode": "195",
    "regionName": "서울특별시 용산구",
    "obesityRate": 24.8,
    "depressionRate": 2.6,
    "population": 213151,
    "coordinates": [
        37.549901000000006,
        126.98061299999999
    ]
},
  {
    "regionCode": "196",
    "regionName": "서울특별시 은평구",
    "obesityRate": 29.8,
    "depressionRate": 6.6,
    "population": 466770,
    "coordinates": [
        37.605314,
        126.93456700000002
    ]
},
  {
    "regionCode": "197",
    "regionName": "서울특별시 종로구",
    "obesityRate": 26.2,
    "depressionRate": 8.9,
    "population": 139417,
    "coordinates": [
        37.584009,
        126.970626
    ]
},
  {
    "regionCode": "198",
    "regionName": "서울특별시 중구",
    "obesityRate": 26.9,
    "depressionRate": 5.1,
    "population": 121312,
    "coordinates": [
        37.564079,
        126.98004599999999
    ]
},
  {
    "regionCode": "199",
    "regionName": "서울특별시 중랑구",
    "obesityRate": 32.8,
    "depressionRate": 6.4,
    "population": 382155,
    "coordinates": [
        37.606736,
        127.092924
    ]
},
  {
    "regionCode": "203",
    "regionName": "울산광역시 남구",
    "obesityRate": 32.5,
    "depressionRate": 6.8,
    "population": 307232,
    "coordinates": [
        35.54138700000001,
        129.306529
    ]
},
  {
    "regionCode": "204",
    "regionName": "울산광역시 동구",
    "obesityRate": 35.4,
    "depressionRate": 8.0,
    "population": 152287,
    "coordinates": [
        35.49390400000001,
        129.410745
    ]
},
  {
    "regionCode": "205",
    "regionName": "울산광역시 북구",
    "obesityRate": 34.4,
    "depressionRate": 8.0,
    "population": 216477,
    "coordinates": [
        35.622741,
        129.356035
    ]
},
  {
    "regionCode": "207",
    "regionName": "울산광역시 울주군",
    "obesityRate": 33.4,
    "depressionRate": 7.5,
    "population": 218997,
    "coordinates": [
        35.43072599999999,
        129.328614
    ]
},
  {
    "regionCode": "208",
    "regionName": "울산광역시 중구",
    "obesityRate": 33.9,
    "depressionRate": 7.7,
    "population": 208668,
    "coordinates": [
        35.55478599999999,
        129.334772
    ]
},
  {
    "regionCode": "209",
    "regionName": "인천광역시 강화군",
    "obesityRate": 32.9,
    "depressionRate": 9.4,
    "population": 69005,
    "coordinates": [
        37.75255,
        126.48738600000001
    ]
},
  {
    "regionCode": "210",
    "regionName": "인천광역시 계양구",
    "obesityRate": 35.0,
    "depressionRate": 6.1,
    "population": 280266,
    "coordinates": [
        37.532402,
        126.712115
    ]
},
  {
    "regionCode": "211",
    "regionName": "인천광역시 남동구",
    "obesityRate": 36.4,
    "depressionRate": 8.8,
    "population": 492415,
    "coordinates": [
        37.452403999999994,
        126.71162399999999
    ]
},
  {
    "regionCode": "212",
    "regionName": "인천광역시 동구",
    "obesityRate": 34.8,
    "depressionRate": 7.6,
    "population": 59482,
    "coordinates": [
        37.486203,
        126.620745
    ]
},
  {
    "regionCode": "213",
    "regionName": "인천광역시 미추홀구",
    "obesityRate": 33.1,
    "depressionRate": 7.2,
    "population": 405995,
    "coordinates": [
        37.45982000000001,
        126.64792799999998
    ]
},
  {
    "regionCode": "214",
    "regionName": "인천광역시 부평구",
    "obesityRate": 36.1,
    "depressionRate": 5.7,
    "population": 494138,
    "coordinates": [
        37.494168,
        126.720032
    ]
},
  {
    "regionCode": "215",
    "regionName": "인천광역시 서구",
    "obesityRate": 32.2,
    "depressionRate": 6.0,
    "population": 624358,
    "coordinates": [
        37.564367,
        126.67359
    ]
},
  {
    "regionCode": "216",
    "regionName": "인천광역시 연수구",
    "obesityRate": 28.3,
    "depressionRate": 6.0,
    "population": 392416,
    "coordinates": [
        37.42740200000001,
        126.65516600000001
    ]
},
  {
    "regionCode": "219",
    "regionName": "인천광역시 중구",
    "obesityRate": 34.1,
    "depressionRate": 8.9,
    "population": 158958,
    "coordinates": [
        37.45317000000001,
        126.604489
    ]
},
  {
    "regionCode": "220",
    "regionName": "전라남도 강진군",
    "obesityRate": 36.5,
    "depressionRate": 5.0,
    "population": 32722,
    "coordinates": [
        34.630742999999995,
        126.739839
    ]
},
  {
    "regionCode": "221",
    "regionName": "전라남도 고흥군",
    "obesityRate": 30.5,
    "depressionRate": 4.0,
    "population": 61113,
    "coordinates": [
        34.602279,
        127.277214
    ]
},
  {
    "regionCode": "222",
    "regionName": "전라남도 곡성군",
    "obesityRate": 30.8,
    "depressionRate": 1.4,
    "population": 26905,
    "coordinates": [
        35.28004,
        127.27115400000001
    ]
},
  {
    "regionCode": "223",
    "regionName": "전라남도 광양시",
    "obesityRate": 36.1,
    "depressionRate": 4.1,
    "population": 152666,
    "coordinates": [
        34.95814099999999,
        127.603487
    ]
},
  {
    "regionCode": "225",
    "regionName": "전라남도 나주시",
    "obesityRate": 36.2,
    "depressionRate": 4.7,
    "population": 117377,
    "coordinates": [
        35.02855,
        126.862589
    ]
},
  {
    "regionCode": "227",
    "regionName": "전라남도 목포시",
    "obesityRate": 38.3,
    "depressionRate": 8.2,
    "population": 214156,
    "coordinates": [
        34.805944,
        126.39178799999999
    ]
},
  {
    "regionCode": "228",
    "regionName": "전라남도 무안군",
    "obesityRate": 35.1,
    "depressionRate": 2.1,
    "population": 90296,
    "coordinates": [
        34.992461,
        126.47129099999998
    ]
},
  {
    "regionCode": "229",
    "regionName": "전라남도 보성군",
    "obesityRate": 31.0,
    "depressionRate": 5.0,
    "population": 37686,
    "coordinates": [
        34.75102199999999,
        127.06966000000001
    ]
},
  {
    "regionCode": "230",
    "regionName": "전라남도 순천시",
    "obesityRate": 34.4,
    "depressionRate": 3.7,
    "population": 278137,
    "coordinates": [
        35.01760000000001,
        127.362103
    ]
},
  {
    "regionCode": "231",
    "regionName": "전라남도 신안군",
    "obesityRate": 32.4,
    "depressionRate": 3.5,
    "population": 38037,
    "coordinates": [
        35.060483,
        126.21025100000001
    ]
},
  {
    "regionCode": "232",
    "regionName": "전라남도 여수시",
    "obesityRate": 35.3,
    "depressionRate": 5.4,
    "population": 271696,
    "coordinates": [
        34.645775,
        127.762203
    ]
},
  {
    "regionCode": "233",
    "regionName": "전라남도 영광군",
    "obesityRate": 35.7,
    "depressionRate": 6.0,
    "population": 51750,
    "coordinates": [
        35.294801,
        126.505709
    ]
},
  {
    "regionCode": "234",
    "regionName": "전라남도 영암군",
    "obesityRate": 35.0,
    "depressionRate": 5.0,
    "population": 52350,
    "coordinates": [
        34.791123,
        126.724915
    ]
},
  {
    "regionCode": "235",
    "regionName": "전라남도 완도군",
    "obesityRate": 35.1,
    "depressionRate": 11.4,
    "population": 46641,
    "coordinates": [
        34.328584,
        126.71575200000001
    ]
},
  {
    "regionCode": "236",
    "regionName": "전라남도 장성군",
    "obesityRate": 29.9,
    "depressionRate": 4.8,
    "population": 42543,
    "coordinates": [
        35.326538000000006,
        126.815867
    ]
},
  {
    "regionCode": "237",
    "regionName": "전라남도 장흥군",
    "obesityRate": 31.1,
    "depressionRate": 6.4,
    "population": 35046,
    "coordinates": [
        34.67974499999999,
        126.90497200000001
    ]
},
  {
    "regionCode": "239",
    "regionName": "전라남도 진도군",
    "obesityRate": 31.2,
    "depressionRate": 3.2,
    "population": 28979,
    "coordinates": [
        34.490403,
        126.240049
    ]
},
  {
    "regionCode": "240",
    "regionName": "전라남도 함평군",
    "obesityRate": 31.5,
    "depressionRate": 6.7,
    "population": 30601,
    "coordinates": [
        35.067916,
        126.488862
    ]
},
  {
    "regionCode": "241",
    "regionName": "전라남도 해남군",
    "obesityRate": 36.1,
    "depressionRate": 5.3,
    "population": 64575,
    "coordinates": [
        34.558036,
        126.56615500000001
    ]
},
  {
    "regionCode": "242",
    "regionName": "전라남도 화순군",
    "obesityRate": 31.1,
    "depressionRate": 3.1,
    "population": 61254,
    "coordinates": [
        35.06216400000001,
        126.96332199999999
    ]
},
  {
    "regionCode": "243",
    "regionName": "전라북도 고창군",
    "obesityRate": 34.5,
    "depressionRate": 9.4,
    "population": 51750,
    "coordinates": [
        35.432089,
        126.703911
    ]
},
  {
    "regionCode": "244",
    "regionName": "전라북도 군산시",
    "obesityRate": 33.7,
    "depressionRate": 6.2,
    "population": 259980,
    "coordinates": [
        35.905719,
        126.69094699999998
    ]
},
  {
    "regionCode": "245",
    "regionName": "전라북도 김제시",
    "obesityRate": 34.2,
    "depressionRate": 7.2,
    "population": 81430,
    "coordinates": [
        35.868685000000006,
        126.823212
    ]
},
  {
    "regionCode": "246",
    "regionName": "전라북도 남원시",
    "obesityRate": 32.1,
    "depressionRate": 12.4,
    "population": 76781,
    "coordinates": [
        35.430535,
        127.53541400000002
    ]
},
  {
    "regionCode": "247",
    "regionName": "전라북도 무주군",
    "obesityRate": 30.9,
    "depressionRate": 4.7,
    "population": 23251,
    "coordinates": [
        36.011514999999996,
        127.655877
    ]
},
  {
    "regionCode": "248",
    "regionName": "전라북도 부안군",
    "obesityRate": 37.2,
    "depressionRate": 6.6,
    "population": 49187,
    "coordinates": [
        35.708655,
        126.74489900000002
    ]
},
  {
    "regionCode": "249",
    "regionName": "전라북도 순창군",
    "obesityRate": 32.4,
    "depressionRate": 5.2,
    "population": 26764,
    "coordinates": [
        35.370442,
        127.13341
    ]
},
  {
    "regionCode": "250",
    "regionName": "전라북도 완주군",
    "obesityRate": 29.4,
    "depressionRate": 4.8,
    "population": 97827,
    "coordinates": [
        35.912986000000004,
        127.085409
    ]
},
  {
    "regionCode": "251",
    "regionName": "전라북도 익산시",
    "obesityRate": 33.6,
    "depressionRate": 7.9,
    "population": 270036,
    "coordinates": [
        36.061415,
        126.96436900000002
    ]
},
  {
    "regionCode": "252",
    "regionName": "전라북도 임실군",
    "obesityRate": 25.8,
    "depressionRate": 7.4,
    "population": 25956,
    "coordinates": [
        35.592447,
        127.26668900000001
    ]
},
  {
    "regionCode": "253",
    "regionName": "전라북도 장수군",
    "obesityRate": 24.9,
    "depressionRate": 7.9,
    "population": 20983,
    "coordinates": [
        35.62364900000001,
        127.511492
    ]
},
  {
    "regionCode": "258",
    "regionName": "전라북도 정읍시",
    "obesityRate": 34.3,
    "depressionRate": 5.3,
    "population": 103620,
    "coordinates": [
        35.701421,
        126.87169699999998
    ]
},
  {
    "regionCode": "260",
    "regionName": "제주특별자치도 서귀포시",
    "obesityRate": 35.4,
    "depressionRate": 6.8,
    "population": 183598,
    "coordinates": [
        33.25644599999999,
        126.24703400000001
    ]
},
  {
    "regionCode": "264",
    "regionName": "제주특별자치도 제주시",
    "obesityRate": 36.5,
    "depressionRate": 4.4,
    "population": 491654,
    "coordinates": [
        33.376347,
        126.284734
    ]
},
  {
    "regionCode": "269",
    "regionName": "충청남도 계룡시",
    "obesityRate": 32.6,
    "depressionRate": 2.5,
    "population": 46667,
    "coordinates": [
        36.252862,
        127.26005600000002
    ]
},
  {
    "regionCode": "270",
    "regionName": "충청남도 공주시",
    "obesityRate": 32.2,
    "depressionRate": 6.8,
    "population": 102104,
    "coordinates": [
        36.596512000000004,
        126.96837200000002
    ]
},
  {
    "regionCode": "271",
    "regionName": "충청남도 금산군",
    "obesityRate": 33.5,
    "depressionRate": 10.1,
    "population": 50093,
    "coordinates": [
        36.095856,
        127.47190600000002
    ]
},
  {
    "regionCode": "272",
    "regionName": "충청남도 논산시",
    "obesityRate": 30.0,
    "depressionRate": 8.4,
    "population": 110423,
    "coordinates": [
        36.152662,
        127.018313
    ]
},
  {
    "regionCode": "273",
    "regionName": "충청남도 당진시",
    "obesityRate": 37.1,
    "depressionRate": 8.2,
    "population": 170302,
    "coordinates": [
        36.79309000000001,
        126.77436900000001
    ]
},
  {
    "regionCode": "274",
    "regionName": "충청남도 보령시",
    "obesityRate": 30.4,
    "depressionRate": 2.4,
    "population": 95772,
    "coordinates": [
        36.242946,
        126.589147
    ]
},
  {
    "regionCode": "275",
    "regionName": "충청남도 부여군",
    "obesityRate": 31.4,
    "depressionRate": 4.5,
    "population": 61046,
    "coordinates": [
        36.28624700000001,
        126.94778100000002
    ]
},
  {
    "regionCode": "276",
    "regionName": "충청남도 서산시",
    "obesityRate": 35.6,
    "depressionRate": 12.6,
    "population": 176011,
    "coordinates": [
        36.965514000000006,
        126.42071300000002
    ]
},
  {
    "regionCode": "277",
    "regionName": "충청남도 서천군",
    "obesityRate": 32.0,
    "depressionRate": 5.8,
    "population": 49116,
    "coordinates": [
        36.020084,
        126.68732800000001
    ]
},
  {
    "regionCode": "278",
    "regionName": "충청남도 아산시",
    "obesityRate": 37.4,
    "depressionRate": 6.3,
    "population": 345796,
    "coordinates": [
        36.82176,
        126.982215
    ]
},
  {
    "regionCode": "279",
    "regionName": "충청남도 예산군",
    "obesityRate": 31.8,
    "depressionRate": 10.2,
    "population": 78354,
    "coordinates": [
        36.70374300000001,
        126.855025
    ]
},
  {
    "regionCode": "283",
    "regionName": "충청남도 청양군",
    "obesityRate": 33.5,
    "depressionRate": 4.4,
    "population": 30168,
    "coordinates": [
        36.448819,
        126.79017000000002
    ]
},
  {
    "regionCode": "285",
    "regionName": "충청남도 태안군",
    "obesityRate": 33.7,
    "depressionRate": 7.4,
    "population": 60784,
    "coordinates": [
        36.753517,
        126.31257400000001
    ]
},
  {
    "regionCode": "286",
    "regionName": "충청남도 홍성군",
    "obesityRate": 34.8,
    "depressionRate": 8.5,
    "population": 97524,
    "coordinates": [
        36.593042000000004,
        126.66273599999998
    ]
},
  {
    "regionCode": "287",
    "regionName": "충청북도 괴산군",
    "obesityRate": 34.6,
    "depressionRate": 9.2,
    "population": 36590,
    "coordinates": [
        36.827128,
        127.805132
    ]
},
  {
    "regionCode": "289",
    "regionName": "충청북도 보은군",
    "obesityRate": 38.5,
    "depressionRate": 9.1,
    "population": 31010,
    "coordinates": [
        36.499159000000006,
        127.72313
    ]
},
  {
    "regionCode": "290",
    "regionName": "충청북도 영동군",
    "obesityRate": 31.4,
    "depressionRate": 5.2,
    "population": 44195,
    "coordinates": [
        36.177499000000005,
        127.810632
    ]
},
  {
    "regionCode": "291",
    "regionName": "충청북도 옥천군",
    "obesityRate": 34.6,
    "depressionRate": 5.3,
    "population": 48891,
    "coordinates": [
        36.30150799999999,
        127.583737
    ]
},
  {
    "regionCode": "292",
    "regionName": "충청북도 음성군",
    "obesityRate": 38.3,
    "depressionRate": 7.3,
    "population": 91183,
    "coordinates": [
        36.941694,
        127.654401
    ]
},
  {
    "regionCode": "294",
    "regionName": "충청북도 증평군",
    "obesityRate": 38.0,
    "depressionRate": 7.5,
    "population": 37484,
    "coordinates": [
        36.766861000000006,
        127.60393000000002
    ]
},
  {
    "regionCode": "295",
    "regionName": "충청북도 진천군",
    "obesityRate": 36.5,
    "depressionRate": 8.0,
    "population": 86254,
    "coordinates": [
        36.847832,
        127.41407900000002
    ]
},
  {
    "regionCode": "301",
    "regionName": "충청북도 충주시",
    "obesityRate": 35.2,
    "depressionRate": 8.8,
    "population": 207778,
    "coordinates": [
        36.986264,
        127.78332699999999
    ]
},
];

export const gwrCoefficients = [
  {
    regionCode: '11010',
    variable: '주점업 수',
    coefficient: 0.045,
    pValue: 0.023,
    localR2: 0.67,
    dependentVar: 'obesity'
  },
  {
    regionCode: '11010',
    variable: '체육시설 수',
    coefficient: -0.032,
    pValue: 0.015,
    localR2: 0.67,
    dependentVar: 'obesity'
  },
  {
    regionCode: '11010',
    variable: '공원 면적',
    coefficient: -0.028,
    pValue: 0.041,
    localR2: 0.67,
    dependentVar: 'obesity'
  },
  {
    regionCode: '11010',
    variable: '편의점 수',
    coefficient: 0.021,
    pValue: 0.067,
    localR2: 0.67,
    dependentVar: 'obesity'
  },
  {
    regionCode: '11020',
    variable: '주점업 수',
    coefficient: 0.038,
    pValue: 0.031,
    localR2: 0.72,
    dependentVar: 'obesity'
  },
  {
    regionCode: '11020',
    variable: '체육시설 수',
    coefficient: -0.041,
    pValue: 0.012,
    localR2: 0.72,
    dependentVar: 'obesity'
  }
];

export const physicalFactors = [
  { id: 'bars', name: '주점업 수', unit: '개소' },
  { id: 'fastfood', name: '패스트푸드점 수', unit: '개소' },
  { id: 'parks', name: '공원 면적', unit: 'm²' },
  { id: 'num_park', name: '공원 수', unit: '개소' },
  { id: 'public_trans', name: '대중교통 만족도', unit: '점수' }
];

export const dependentVariables = [
  { id: 'obesity', name: '비만율', unit: '%' },
  { id: 'depression', name: '우울감 경험률', unit: '%' }
];